import { getRoundedCornersBox, getSectionProps } from 'utils/styles';
import { CompareVariant } from 'types/constants';
import { CompareProps } from './types';
import RichTextTable from 'components/shared/RichTextTable/RichTextTable';
import CompareGraph from './CompareGraph';

const Compare = ({
  sectionName,
  content,
  color,
  margins,
  highlightedColumnIndex,
  highlightColor,
  mobileDropdownVariant,
  variant,
  roundedCorners,
  graphDescription,
  compareTableVariables,
}: CompareProps) => {
  const isGraph = variant === CompareVariant.Graph;

  return (
    <section {...getSectionProps(color, margins, sectionName, getRoundedCornersBox(roundedCorners))}>
      <div className="content-wrapper">
        {isGraph ? (
          <CompareGraph description={graphDescription} variables={compareTableVariables?.items ?? []} />
        ) : (
          content && (
            <RichTextTable
              content={content}
              color={color}
              highlightedColumnIndex={highlightedColumnIndex}
              highlightColor={highlightColor}
              mobileDropdownVariant={mobileDropdownVariant}
            />
          )
        )}
      </div>
    </section>
  );
};
export default Compare;
